exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icon-active-size{font-size:1.8rem;vertical-align:middle}.icon-shared-size{font-size:1.5rem;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/situation-status-icons.scss
// module id = 112
// module chunks = 0